let base = 'BRL';
let usdBrl = null;
let quotedAt = null;

export function moedaBase() {
  return base === 'USD' ? 'USD' : 'BRL';
}

export function setMoedaBase(next) {
  base = String(next || 'BRL').toUpperCase() === 'USD' ? 'USD' : 'BRL';
}

export function taxaUsdBrl() {
  const rate = Number(usdBrl);
  return rate > 0 ? rate : null;
}

export function cotacaoLabel() {
  if (!taxaUsdBrl()) return '';
  const dia = quotedAt || '';
  return `US$ 1 = R$ ${taxaUsdBrl().toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })}${dia ? ` (${dia})` : ''}`;
}

export function setTaxaUsdBrl(rate, day) {
  const value = Number(rate);
  usdBrl = value > 0 ? value : null;
  quotedAt = day || null;
}

export function roundMoney(amount) {
  const value = Number(amount);
  if (!Number.isFinite(value)) return 0;
  return Math.round(value * 100) / 100;
}

export function paraBase(amount, origem = 'BRL') {
  const value = Number(amount) || 0;
  const from = String(origem || 'BRL').toUpperCase();
  const to = moedaBase();
  if (from === to) return roundMoney(value);
  const rate = taxaUsdBrl();
  if (!(rate > 0) || (from !== 'BRL' && from !== 'USD')) return roundMoney(value);
  const brl = from === 'USD' ? value * rate : value;
  return to === 'USD' ? roundMoney(brl / rate) : roundMoney(brl);
}

export function paraBrl(amount, origem = 'BRL') {
  const value = Number(amount) || 0;
  const from = String(origem || 'BRL').toUpperCase();
  if (from === 'BRL') return roundMoney(value);
  if (from === 'USD') {
    const rate = taxaUsdBrl();
    return rate > 0 ? roundMoney(value * rate) : roundMoney(value);
  }
  return roundMoney(value);
}

export function paraOrigem(amountBase, origem = 'BRL') {
  const value = Number(amountBase) || 0;
  const to = String(origem || 'BRL').toUpperCase();
  const from = moedaBase();
  if (from === to) return roundMoney(value);
  const rate = taxaUsdBrl();
  if (!(rate > 0)) return roundMoney(value);
  const brl = from === 'USD' ? value * rate : value;
  return to === 'USD' ? roundMoney(brl / rate) : roundMoney(brl);
}

export function fmtValor(amount) {
  const currency = moedaBase();
  return (Number(amount) || 0).toLocaleString(currency === 'USD' ? 'en-US' : 'pt-BR', {
    style: 'currency',
    currency,
  });
}

export function simboloMoeda() {
  return moedaBase() === 'USD' ? 'US$' : 'R$';
}
